// No-op tracer — safe to call from anywhere, emits nothing. Used until the
// OTel SDK + collector backend are in place. Replacing this file with a real
// implementation is the entire migration path; callers don't change.

import type { Span, SpanAttributeValue, Tracer, TraceContext } from './tracerTypes'

const noopSpan: Span = {
  name: '',
  setAttribute(): void {},
  setAttributes(): void {},
  addEvent(): void {},
  setStatus(): void {},
  recordException(): void {},
  end(): void {},
}

export const noopTracer: Tracer = {
  startSpan(_name: string, _attrs?: Record<string, SpanAttributeValue>): Span {
    return noopSpan
  },

  withSpan<T>(
    _name: string,
    fn: (span: Span) => T | Promise<T>,
    _attrs?: Record<string, SpanAttributeValue>,
  ): T | Promise<T> {
    return fn(noopSpan)
  },

  getActiveContext(): TraceContext | undefined {
    return undefined
  },
}
